// removed by extract-text-webpack-plugin
module.exports = {"crown":"crown___1X1O_","crown-inner":"crown-inner___2tA0c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Crown.scss
// module id = JUtZ
// module chunks = 46